export const authToken = () => JSON.parse(localStorage.getItem("b2c:authToken"));
